<template>
  <div>
    <div id="graphContainer" class="graph-container"></div>

    <side-bar :pouTempId="pouTempId"></side-bar>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row v-if="editedObj.elementType === 'comment'">
              <v-col cols="12">
                <v-textarea
                  label="Comment"
                  v-model="editedObj.value"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'connection'">
              <v-col cols="6">
                <v-select
                  label="Type"
                  :items="connectionTypes"
                  v-model="editedObj.type"
                ></v-select>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  label="Name"
                  v-model="editedObj.name"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" text type="submit" @click="saveCell"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mapValues,
  map,
  filter,
  find,
  some,
  values,
  flatten,
  isNil,
} from "lodash";

const stringify = require("json-stringify-safe");
const { create } = require("xmlbuilder2");
const convert = require("xml-js");
import graph from "src/mixins/graph";
import SideBar from "./SideBar";

export default {
  name: "FBDGraph",
  props: ["pouTempId"],
  components: { SideBar },
  mixins: [graph],
  data() {
    return {
      name: "FBD",
    };
  },
  computed: {
    vars() {
      return find(this.$store.state.pous, { tempId: this.pouTempId }).variables;
    },
    pous() {
      return this.$store.state.pous;
    },
    pou() {
      return find(this.$store.state.pous, { tempId: this.pouTempId });
    },
  },
};
</script>

<style lang="scss" scoped>
.graph-container {
  flex-grow: 2;
  cursor: default;
  background: url("https://jgraph.github.io/mxgraph/javascript/examples/editors/images/grid.gif");
}
</style>
